import { Dialog, DialogContent, DialogClose } from '@/components/atoms/Dialog';
import { Button } from '@/components/atoms/PcButton';

const CHROME_WEBSTORE_URL =
  'https://chromewebstore.google.com/detail/sellerbox-monitoring-agent';

interface ExtensionInstallDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const ExtensionInstallDialog = ({ open, onOpenChange }: ExtensionInstallDialogProps) => {
  const handleDownload = () => {
    window.open(CHROME_WEBSTORE_URL, '_blank');
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent noCloseBtn className="w-[360px] p-[30px]">
        <div className="flex flex-col items-start">
          <div className="text-gr-900 Title3S18">확장 프로그램 설치가 필요해요!</div>
          <div className="mt-[4px] text-gr-700 Body5M14">
            매일 오전 11시 상품 순위를 알려드릴게요.
            <br />
            상품의 순위 변화를 파악하고 판매 전략을 세워보세요.
          </div>
          <div className="mt-[20px] flex w-full gap-3">
            <DialogClose asChild>
              <Button variant="muted" className="h-[48px] flex-1">
                취소
              </Button>
            </DialogClose>
            <Button variant="default" className="h-[48px] flex-1" onClick={handleDownload}>
              확장 프로그램 다운
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ExtensionInstallDialog;
